export function getThemeValue<Value>(
  values: Readonly<Partial<Record<string, Value>>>,
  key: string
): Value | undefined {
  return values[key];
}
